import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {AcademicsInterface} from "../../../services/interface/query/academics-interface";
import {ItemInfo, ItemInfoSpouse} from "../../components/ViewData";
import * as IconMaterial from "@mui/icons-material";
import {Person} from "../../../services/interface/query/person";
import NotPermissionComponent from "../NotPermissionComponent";
import {useFindAcademics} from "../../../services/apis/apiAcademic";
import NoRecords from "../../components/NoRecords";

interface Props {
    person?: Person;
}

export default function Academics({person}: Props) {
    const {t} = useTranslation("global") as { t: (key: string) => string };

    const {
        mutate: findAcademics,
        data: successFindAcademics,
        error: errorFindAcademics,
        isPending: loadingFindAcademics,
    } = useFindAcademics()

    const [list, setList] = React.useState<AcademicsInterface[] | undefined>()
    const styleIcon = 'max-w-[20px] max-h-[20px]'

    useEffect(() => {
        if (person && person.identification) {
            setList(undefined)
            findAcademics({identifier: person.identification, msj: t('academics')})
        }
    }, [person]);

    useEffect(() => {
        if (successFindAcademics) {
            setList(successFindAcademics)
        }
    }, [successFindAcademics]);

    return (
        <div className={'flex flex-col gap-3'}>
            <h3 className={'capitalize'}>{t('academics')}</h3>
            <NotPermissionComponent
                title={'/income/current'}
                loading={loadingFindAcademics}
                error={errorFindAcademics}
                component={<>
                    {(!loadingFindAcademics && list && list.length > 0) ?
                        <>
                            {list.map((item, index) => (
                                <div key={index}>
                                    <h5>{`${t('register')} #${index + 1}`}</h5>
                                    <div className={'mt-1 custom-card py-3 px-3 flex flex-col gap-2 '}>
                                        <div className={'grid sm:grid-cols-2 md:grid-cols-2 gap-2'}>
                                            <ItemInfo
                                                label={t('university-name')}
                                                text={item.educationalInstitution_description}
                                                icon={<IconMaterial.SchoolTwoTone className={styleIcon}/>}
                                            />
                                            <ItemInfo
                                                label={t('registration-date')}
                                                text={item.registrationDate}
                                                icon={<IconMaterial.AccountBalanceTwoTone className={styleIcon}/>}
                                            />
                                        </div>
                                        <div
                                            className={'border border-t-1 border-t-secondary border-transparent pt-3 grid sm:grid-cols-2 md:grid-cols-4 gap-2'}>
                                            <ItemInfoSpouse label={t('name-title')} text={item.title_description}
                                                            className={'text-[13px]'}/>
                                            <ItemInfoSpouse label={t('educational-institution-type')} text={item.educationalInstitutionType_description}
                                                            className={'text-[13px]'}/>
                                            <ItemInfoSpouse label={t('training-level')} text={item.educationLevel_description}
                                                            className={'text-[13px]'}/>
                                            <ItemInfoSpouse label={t('nationality-description')} text={item.nationality_description}
                                                            className={'text-[13px]'}/>
                                        </div>
                                    </div>
                                </div>
                            ))
                            }
                        </> : <NoRecords/>}
                </>}
            />
        </div>
    )
}
